import { useEffect, useState } from 'react';

/**
 * Atrasa a propagação de um valor que muda a cada tecla.
 *
 * Usado na busca da auditoria, que consulta o servidor: sem isso, cada letra
 * digitada viraria uma requisição.
 */
export function useDebounce(valor, ms = 400) {
  const [atrasado, setAtrasado] = useState(valor);

  useEffect(() => {
    const t = setTimeout(() => setAtrasado(valor), ms);
    return () => clearTimeout(t);
  }, [valor, ms]);

  return atrasado;
}

export default useDebounce;
